export default "__VITE_ASSET__D8AwoX5v__"